module.exports = __webpack_public_path__ + "static/img/404.0a38972b.png";